 
import IndexModel from "@/service/v10/sigap/IndexModel";
 
class ConfiguracaoService extends IndexModel { 
       
    constructor() {
        super();
        this.url =  this.url + '/Configuracao' ;  
    }
 
    public getApiUrl(  ) { 
        return this.getAxios().defaults.baseURL + this.url; 
    }
    
    
    public getModelByChave( chave  ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().get( this.url + `?nome=${chave}`  )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }
    
    
    // public getAll( params: any  ) : Promise<any>  { 
    //     return  new Promise((resolve, reject) => {  
    //         this.getAxios().get( this.url + `?${params}` )
    //         .then(response => {    
    //             resolve( response.data);  
    //         })
    //         .catch(error => {   
    //             reject(error.response);
    //         }) 
    //     }); 
    // }
 


    // public getModel( id  ) : Promise<any> { 
    //     return  new Promise((resolve, reject) => {
    //         this.getAxios().get( this.url + '/' + id    )
    //         .then(response => {    
    //             resolve( response.data);  
    //         })
    //         .catch(error => {  
    //             reject(error.response);
    //         }) 
    //     }); 
    // }
    
      


}
  
export default ConfiguracaoService; 